// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function allocation_radius_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var auto = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "auto"), null));
  if (auto.TAG === /* Ok */0) {
    var manual = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "manual"), null));
    if (manual.TAG === /* Ok */0) {
      var radius_delta = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "radius_delta"), null));
      if (radius_delta.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  auto: auto._0,
                  manual: manual._0,
                  radius_delta: radius_delta._0
                }
              };
      }
      var e = radius_delta._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".radius_delta" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = manual._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".manual" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = auto._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".auto" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function dry_run_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var threshold = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "threshold"), null));
  if (threshold.TAG === /* Ok */0) {
    var ratio = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ratio"), null));
    if (ratio.TAG === /* Ok */0) {
      var radius_delta = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "radius_delta"), null));
      if (radius_delta.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  threshold: threshold._0,
                  ratio: ratio._0,
                  radius_delta: radius_delta._0
                }
              };
      }
      var e = radius_delta._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".radius_delta" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = ratio._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".ratio" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = threshold._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".threshold" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function maps_distance_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var manual = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "manual"), null));
  if (manual.TAG === /* Ok */0) {
    var auto = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "auto"), null));
    if (auto.TAG === /* Ok */0) {
      var radius_delta = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "radius_delta"), null));
      if (radius_delta.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  manual: manual._0,
                  auto: auto._0,
                  radius_delta: radius_delta._0
                }
              };
      }
      var e = radius_delta._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".radius_delta" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = auto._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".auto" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = manual._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".manual" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function created_by_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var email_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email_id"), null));
    if (email_id.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                name: name._0,
                email_id: email_id._0
              }
            };
    }
    var e = email_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".email_id" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function creator_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var created_by = created_by_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_by"), null));
  if (created_by.TAG === /* Ok */0) {
    var created_on = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_on"), null));
    if (created_on.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                created_by: created_by._0,
                created_on: created_on._0
              }
            };
    }
    var e = created_on._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".created_on" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = created_by._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".created_by" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function approved_by_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var email_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email_id"), null));
    if (email_id.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                name: name._0,
                email_id: email_id._0
              }
            };
    }
    var e = email_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".email_id" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function approver_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var approved_by = approved_by_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "approved_by"), null));
  if (approved_by.TAG === /* Ok */0) {
    var approved_on = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "approved_on"), null));
    if (approved_on.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                approved_by: approved_by._0,
                approved_on: approved_on._0
              }
            };
    }
    var e = approved_on._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".approved_on" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = approved_by._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".approved_by" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function zone_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                name: name._0,
                id: id._0
              }
            };
    }
    var e = id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".id" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function cluster_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                name: name._0,
                id: id._0
              }
            };
    }
    var e = id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".id" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function filters_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var allocation_radius = allocation_radius_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "allocation_radius"), null));
  if (allocation_radius.TAG === /* Ok */0) {
    var dry_run = dry_run_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dry_run"), null));
    if (dry_run.TAG === /* Ok */0) {
      var maps_distance = maps_distance_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "maps_distance"), null));
      if (maps_distance.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  allocation_radius: allocation_radius._0,
                  dry_run: dry_run._0,
                  maps_distance: maps_distance._0
                }
              };
      }
      var e = maps_distance._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".maps_distance" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = dry_run._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".dry_run" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = allocation_radius._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".allocation_radius" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function allocation_campaign_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var geo_region_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
  if (geo_region_id.TAG === /* Ok */0) {
    var vehicle_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_id"), null));
    if (vehicle_id.TAG === /* Ok */0) {
      var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
        if (id.TAG === /* Ok */0) {
          var campaign_status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "campaign_status"), null));
          if (campaign_status.TAG === /* Ok */0) {
            var effective_from = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "effective_from"), null));
            if (effective_from.TAG === /* Ok */0) {
              var effective_till = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "effective_till"), null));
              if (effective_till.TAG === /* Ok */0) {
                var filters = filters_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "filters"), null));
                if (filters.TAG === /* Ok */0) {
                  var zones = Decco.optionFromJson((function (param) {
                          return Decco.listFromJson(zone_decode, param);
                        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "zones"), null));
                  if (zones.TAG === /* Ok */0) {
                    var clusters = Decco.optionFromJson((function (param) {
                            return Decco.listFromJson(cluster_decode, param);
                          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "clusters"), null));
                    if (clusters.TAG === /* Ok */0) {
                      var creator_info = Decco.optionFromJson(creator_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "creator_info"), null));
                      if (creator_info.TAG === /* Ok */0) {
                        var approver_info = Decco.optionFromJson(approver_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "approver_info"), null));
                        if (approver_info.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    geo_region_id: geo_region_id._0,
                                    vehicle_id: vehicle_id._0,
                                    name: name._0,
                                    id: id._0,
                                    campaign_status: campaign_status._0,
                                    effective_from: effective_from._0,
                                    effective_till: effective_till._0,
                                    filters: filters._0,
                                    zones: zones._0,
                                    clusters: clusters._0,
                                    creator_info: creator_info._0,
                                    approver_info: approver_info._0
                                  }
                                };
                        }
                        var e = approver_info._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".approver_info" + e.path,
                                  message: e.message,
                                  value: e.value
                                }
                              };
                      }
                      var e$1 = creator_info._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".creator_info" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                              }
                            };
                    }
                    var e$2 = clusters._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".clusters" + e$2.path,
                              message: e$2.message,
                              value: e$2.value
                            }
                          };
                  }
                  var e$3 = zones._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".zones" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                          }
                        };
                }
                var e$4 = filters._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".filters" + e$4.path,
                          message: e$4.message,
                          value: e$4.value
                        }
                      };
              }
              var e$5 = effective_till._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".effective_till" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                      }
                    };
            }
            var e$6 = effective_from._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".effective_from" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = campaign_status._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".campaign_status" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
        }
        var e$8 = id._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".id" + e$8.path,
                  message: e$8.message,
                  value: e$8.value
                }
              };
      }
      var e$9 = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e$9.path,
                message: e$9.message,
                value: e$9.value
              }
            };
    }
    var e$10 = vehicle_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vehicle_id" + e$10.path,
              message: e$10.message,
              value: e$10.value
            }
          };
  }
  var e$11 = geo_region_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".geo_region_id" + e$11.path,
            message: e$11.message,
            value: e$11.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var campaigns = Decco.listFromJson(allocation_campaign_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "campaigns"), null));
  if (campaigns.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              campaigns: campaigns._0
            }
          };
  }
  var e = campaigns._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".campaigns" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  allocation_radius_decode ,
  dry_run_decode ,
  maps_distance_decode ,
  created_by_decode ,
  creator_info_decode ,
  approved_by_decode ,
  approver_info_decode ,
  zone_decode ,
  cluster_decode ,
  filters_decode ,
  allocation_campaign_decode ,
  t_decode ,
  
}
/* No side effect */
